// Classic › stats (#1119): the Stats page's own copy. League words (Season,
// Competition, All-time, Per game, …) come from the labels layer.
import { select } from '../../../plural'

const en = {
  subtitle: 'The definitive source for league statistics',
  /** #583: the spotlight's scope with one division picked. */
  divisionLeaders: (division: string) => `${division} leaders`,
  tabs: {
    players: 'Player Stats',
    teams: 'Team Stats',
  },
  filters: {
    team: 'Team',
    allTeams: 'All Teams',
    position: 'Position',
    allPositions: 'All Positions',
    clear: 'Clear',
  },
  table: {
    player: 'Player',
    team: 'Team',
    /** Games played (the column the table always shows). */
    gp: 'GP',
    winLoss: 'W-L',
    winPct: 'WIN%',
  },
  empty: {
    filtered: 'No stats available for the selected filters',
    noGames: (sport: string) =>
      select(sport, {
        soccer: 'Stats show here after the first match.',
        other: 'Stats show here after the first game.',
      }),
    clearFilters: 'Clear Filters',
  },
  paging: {
    showing: (start: number, end: number, total: number) => `Showing ${start}-${end} of ${total}`,
    previous: 'Previous',
    next: 'Next',
  },
}

export default en
